import { useState } from "react";

export const RecordName = ({ api, token, current, onSaved }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(current || "");
  const [error, setError] = useState("");

  const save = async (e) => {
    e.preventDefault();
    setError("");
    const r = await fetch(`${api}/name`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token, name }) }).catch(() => null);
    const j = r ? await r.json().catch(() => ({})) : {};
    if (!r?.ok) return setError(typeof j.detail === "string" ? j.detail : "Up to 12 letters or numbers");
    onSaved({ length: j.length, name: j.name });
    setOpen(false);
  };

  if (!open) {
    return <button className="ss-name-btn" onClick={() => setOpen(true)} data-testid="snake-name-open">{current ? "edit name" : "add your name"}</button>;
  }
  return (
    <form className="ss-name-form" onSubmit={save} data-testid="snake-name-form">
      <input value={name} maxLength={12} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.stopPropagation()}
        placeholder="nickname" autoFocus data-testid="snake-name-input" />
      <button type="submit" disabled={!name.trim()} data-testid="snake-name-save">save</button>
      {error && <span className="ss-name-error" data-testid="snake-name-error">{error}</span>}
    </form>
  );
};
